// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyD_AUzVt9YTpS3iO6jiMLBBWgvLiJE12rU",
    authDomain: "moveme-video.firebaseapp.com",
    projectId: "moveme-video",
    storageBucket: "moveme-video.appspot.com",
    messagingSenderId: "124867521944",
    appId: "1:124867521944:web:a4103da10d9ddb5bfb4fed",
    measurementId: "G-G8ELJ1P4EJ"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export { storage, ref, uploadBytes, uploadBytesResumable, getDownloadURL };




